import { notFound, redirect } from '@tanstack/react-router'
import type { QueryClient } from '@tanstack/react-query'
import { locationSummaryQueryOptions } from '@/api/accommodation/hooks'
import { HttpError } from '@/api/http'

export type UnitSubpage = '' | '/galerie' | '/rezervace' | '/potvrzeni'

/**
 * `/ubytovani/<location>[/<subpage>]` predates units: send it permanently to
 * the same page of the location's first active unit, query string included,
 * so old links, e-mails and index entries keep working. Also accepts the
 * numeric location ID of even older URLs. A location without an active unit
 * (paused or not yet approved) has nothing to show and answers 404.
 */
export async function redirectToFirstUnit(
  queryClient: QueryClient,
  slugOrId: string,
  subpage: UnitSubpage,
  searchStr: string,
): Promise<never> {
  let location
  try {
    location = await queryClient.query({
      ...locationSummaryQueryOptions(slugOrId),
      staleTime: 'static',
    })
  } catch (error) {
    if (error instanceof HttpError && error.status === 404) throw notFound()
    throw error
  }

  const unit = location.units[0]
  if (!unit) throw notFound()

  throw redirect({
    href: `/ubytovani/${location.slug}/${unit.slug}${subpage}${searchStr}`,
    statusCode: 301,
  })
}
